"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throws = throws;
exports.assert = assert;
exports.assertDefined = assertDefined;
exports.assertNumber = assertNumber;
exports.validate = validate;

// Throw an error inline, as an expression
function throws(message) {
  for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    data[_key - 1] = arguments[_key];
  }

  if (data.length > 0) {
    if (data.length === 1) {
      data = data[0];
    }
    message += "\n" + JSON.stringify(data, null, 2);
  }
  throw new Error(message || "assertion error");
}
function assert(cond, message) {
  for (var _len2 = arguments.length, data = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    data[_key2 - 2] = arguments[_key2];
  }

  if (!cond) return throws.apply(undefined, [message].concat(data));
  return cond;
}
function assertDefined(value, message) {
  for (var _len3 = arguments.length, data = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    data[_key3 - 2] = arguments[_key3];
  }

  if (value == null) return throws.apply(undefined, [message].concat(data));
  return value;
}
function assertNumber(value0, message) {
  for (var _len4 = arguments.length, data = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
    data[_key4 - 2] = arguments[_key4];
  }

  var value = assertDefined.apply(undefined, [value0, message].concat(data));
  if (isNaN(value)) return throws.apply(undefined, [message + " (NaN)"].concat(data));
  return value;
}

/**
 * Similar functionality to assertions, but the intent is different:
 * Assertions are programmer error; if they ever fire, there's a bug.
 * Validation could be bad user input, not necessarily a bug.
 */
function validate(cond, message) {
  assert(!!message, "validation requires an error message");

  for (var _len5 = arguments.length, data = Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
    data[_key5 - 2] = arguments[_key5];
  }

  return assert.apply(undefined, [cond, message].concat(data));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../assert/lib/index.js
// module id = 12
// module chunks = 0